  document.addEventListener('DOMContentLoaded', function () {
    // Cart drawer specific functionality
    const cartDrawer = document.querySelector('cart-drawer');

    // Initialize mini collection navigation on page load
    initializeMiniCollectionNavigation();

    // Initialize cart footer breakdown toggle
    if (window.initializeCartFooterToggle) {
      window.initializeCartFooterToggle();
    }

    // ===== NEW COMPLEMENTARY RECOMMENDATIONS SYSTEM =====
    // The new system is loaded via cart-complementary-recommendations.js
    // It automatically handles:
    // - Loading complementary products from Shopify's API
    // - Caching for performance
    // - Rendering using the same card-product template
    // - Event-driven updates when cart changes

    console.log('✅ Cart drawer initialized with complementary recommendations');

    const cartLoader = document.getElementById('cart-drawer-loader');

    function showCartLoader() {
      if (cartLoader) cartLoader.classList.add('active');
    }

    function hideCartLoader() {
      if (cartLoader) cartLoader.classList.remove('active');
    }

    if (cartDrawer) {
      // Prevent form submission for cart drawer
      const cartDrawerForm = document.getElementById('cart-drawer-form');
      if (cartDrawerForm) {
        cartDrawerForm.addEventListener('submit', function (event) {
          event.preventDefault();
          return false;
        });
      }

      // Handle quantity changes specifically for cart drawer
      cartDrawer.addEventListener('change', function (event) {
        if (event.target.matches('.cart-drawer-quantity')) {
          event.preventDefault();
          event.stopPropagation();

          const key = event.target.dataset.lineKey;
          const quantity = parseInt(event.target.value);

          showCartLoader();

          // Update cart via AJAX
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: key,
              quantity: quantity,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              // Refresh cart drawer content
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              hideCartLoader();
            })
            .catch((error) => {
              console.error('Error updating cart:', error);
              hideCartLoader();
            });
        }
      });

      // Handle quantity button clicks specifically for cart drawer
      cartDrawer.addEventListener('click', function (event) {
        const button = event.target.closest('.cart-drawer-minus, .cart-drawer-plus');
        if (button) {
          event.preventDefault();
          event.stopPropagation();

          const quantityInput = button.parentNode.querySelector('.cart-drawer-quantity');

          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value) || 0;
            const isPlus = button.classList.contains('cart-drawer-plus');
            const minValue = parseInt(quantityInput.getAttribute('data-min')) || 0;
            const maxValue = parseInt(quantityInput.getAttribute('max')) || 999;

            // Always increment/decrement by 1, ignore step value
            let newValue;
            if (isPlus) {
              newValue = Math.min(currentValue + 1, maxValue);
            } else {
              newValue = Math.max(currentValue - 1, minValue);
            }

            if (newValue !== currentValue) {
              quantityInput.value = newValue;
              // Trigger change event for cart update
              const changeEvent = new Event('change', { bubbles: true });
              quantityInput.dispatchEvent(changeEvent);
            }
          }
        }
      });

      // Remove button handler removed - now handled by cart-remove-button custom element in cart.js
    }

    // Duplicate listener removed - now handled by consolidated debounced listener above

    // Initialize price stages on load
    setTimeout(() => {
      if (window.initializeCartPriceStages) {
        window.initializeCartPriceStages();
      }
    }, 300);

    // Function to animate price stages (legacy - now uses centralized system)
    function animatePriceStages(container = document) {
      // Trigger centralized initialization instead
      if (window.initializeCartPriceStages) {
        window.initializeCartPriceStages();
      }
    }

    // Function to refresh cart drawer content
    // Function to initialize mini collection loaders
    function initializeMiniCollectionLoaders() {
      const miniCollectionContainer = document.querySelector('.cart-drawer__mini-collection');
      if (miniCollectionContainer) {
        const miniCollectionItems = miniCollectionContainer.querySelectorAll('.cart-drawer__mini-collection-item');
        miniCollectionItems.forEach((item) => {
          if (!item.querySelector('.mini-collection-loader')) {
            const loader = document.createElement('div');
            loader.className = 'mini-collection-loader';
            loader.innerHTML = `
              <svg class="spinner" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20"></circle>
              </svg>
            `;
            item.appendChild(loader);
          }
        });
      }
    }

    // Function to initialize mini collection navigation
    function initializeMiniCollectionNavigation() {
      const miniCollectionWrappers = document.querySelectorAll('.cart-drawer__mini-collection-wrapper');

      miniCollectionWrappers.forEach((wrapper) => {
        const scrollContainer = wrapper.querySelector('.cart-drawer__mini-collection-scroll');
        const prevButton = wrapper.querySelector('.cart-drawer__mini-collection-nav--prev');
        const nextButton = wrapper.querySelector('.cart-drawer__mini-collection-nav--next');

        if (!scrollContainer || !prevButton || !nextButton) return;

        // Check if navigation is needed
        function updateNavigationVisibility() {
          const canScrollLeft = scrollContainer.scrollLeft > 0;
          const canScrollRight = scrollContainer.scrollLeft < scrollContainer.scrollWidth - scrollContainer.clientWidth;
          const needsNavigation = scrollContainer.scrollWidth > scrollContainer.clientWidth;

          if (needsNavigation && window.innerWidth > 990) {
            prevButton.classList.toggle('visible', canScrollLeft);
            nextButton.classList.toggle('visible', canScrollRight);
          } else {
            prevButton.classList.remove('visible');
            nextButton.classList.remove('visible');
          }
        }

        // Navigation button handlers
        prevButton.addEventListener('click', () => {
          const itemWidth = 160 + 16; // item width + gap
          scrollContainer.scrollBy({ left: -itemWidth * 2, behavior: 'smooth' });
        });

        nextButton.addEventListener('click', () => {
          const itemWidth = 160 + 16; // item width + gap
          scrollContainer.scrollBy({ left: itemWidth * 2, behavior: 'smooth' });
        });

        // Update navigation on scroll
        scrollContainer.addEventListener('scroll', updateNavigationVisibility);

        // Update navigation on resize
        window.addEventListener('resize', updateNavigationVisibility);

        // Initial check
        setTimeout(updateNavigationVisibility, 100);
      });
    }

    // Function to initialize cart footer breakdown toggle
    // Make it globally accessible for reinitialization after DOM updates
    window.initializeCartFooterToggle = function () {
      const toggleButton = document.querySelector('.cart-footer__breakdown-toggle');
      const breakdown = document.querySelector('.cart-footer__price-breakdown');
      const subtotal = document.querySelector('.cart-footer__subtotal');

      if (!toggleButton || !breakdown || !subtotal) {
        console.log('Cart footer toggle elements not found');
        return;
      }

      // Remove existing event listener by cloning the button
      const newToggleButton = toggleButton.cloneNode(true);
      toggleButton.parentNode.replaceChild(newToggleButton, toggleButton);

      // Add fresh event listener to the new button
      newToggleButton.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          // Collapse
          this.setAttribute('aria-expanded', 'false');
          breakdown.classList.remove('expanded');
          subtotal.classList.remove('has-expanded-breakdown');
        } else {
          // Expand
          this.setAttribute('aria-expanded', 'true');
          breakdown.classList.add('expanded');
          subtotal.classList.add('has-expanded-breakdown');
        }
      });

      console.log('Cart footer toggle initialized');
    };

    function refreshCartDrawer() {
      console.log('Refreshing cart drawer...');
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        // First try to get fresh cart data
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cartData) => {
            console.log('Cart data updated:', cartData);
            // Now refresh the drawer HTML
            return fetch(window.location.pathname + '?section_id=cart-drawer');
          })
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('cart-drawer .drawer__inner');
            const currentDrawer = cartDrawer.querySelector('.drawer__inner');

            if (newDrawer && currentDrawer) {
              // Store current scroll position before replacing content
              const scrollContainer = cartDrawer.querySelector('.cart-drawer__scrollable');
              const currentScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;
              console.log('Function 2 - Before content replacement - scroll position:', currentScrollTop);

              currentDrawer.innerHTML = newDrawer.innerHTML;
              console.log('Function 2 - Cart drawer refreshed successfully');
              console.log(
                'Function 2 - After content replacement - scroll position:',
                scrollContainer ? scrollContainer.scrollTop : 0
              );

              // Restore scroll position after content replacement
              if (scrollContainer && currentScrollTop > 0) {
                requestAnimationFrame(() => {
                  const newScrollContainer = cartDrawer.querySelector('.cart-drawer__scrollable');
                  if (newScrollContainer) {
                    console.log('Function 2 - Restoring scroll position to:', currentScrollTop);
                    newScrollContainer.scrollTop = currentScrollTop;
                    console.log('Function 2 - After restoration - scroll position:', newScrollContainer.scrollTop);
                  }
                });
              }

              // Re-animate progress bar after refresh
              animatePriceStages(currentDrawer);

              // Re-initialize mini collection loaders
              initializeMiniCollectionLoaders();

              // Re-initialize mini collection navigation
              initializeMiniCollectionNavigation();

              // Re-initialize cart footer toggle
              if (window.initializeCartFooterToggle) {
                window.initializeCartFooterToggle();
              }

              // Dispatch cart:drawer:refreshed event to trigger recommendations loading
              fetch('/cart.js')
                .then((response) => response.json())
                .then((freshCartData) => {
                  console.log('Dispatching cart:drawer:refreshed event with cart data');
                  document.dispatchEvent(
                    new CustomEvent('cart:drawer:refreshed', {
                      detail: {
                        cartData: freshCartData,
                        itemCount: freshCartData.item_count,
                      },
                    })
                  );
                })
                .catch((error) => {
                  console.error('Failed to fetch cart data for event:', error);
                  // Dispatch event anyway without cart data
                  document.dispatchEvent(
                    new CustomEvent('cart:drawer:refreshed', {
                      detail: {},
                    })
                  );
                });
            }
          })
          .catch((error) => {
            console.error('Error refreshing cart drawer:', error);
          });
      }
    }

    // Make refresh function globally available
    window.refreshCartDrawer = refreshCartDrawer;

    // === GIFT ORDER CHECKBOX HANDLER ===
    function syncGiftCheckboxState() {
      const giftCheckbox = document.getElementById('cart-gift-checkbox');
      if (!giftCheckbox) return;

      const variantId = giftCheckbox.dataset.variantId;
      if (!variantId) return;

      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const giftItem = cart.items.find((item) => item.variant_id == variantId);
          const shouldBeChecked = !!giftItem;
          if (giftCheckbox.checked !== shouldBeChecked) {
            giftCheckbox.checked = shouldBeChecked;
          }
        })
        .catch((error) => {
          console.error('Error syncing gift checkbox state:', error);
        });
    }

    function handleGiftCheckboxChange(event) {
      const giftCheckbox = event.target;

      // Check if already processing
      if (giftCheckbox.dataset.processing === 'true') {
        event.preventDefault();
        giftCheckbox.checked = !giftCheckbox.checked;
        return;
      }

      const variantId = giftCheckbox.dataset.variantId;
      const isChecked = giftCheckbox.checked;

      if (!variantId) {
        console.error('Gift variant ID not found');
        return;
      }

      // Mark as processing
      giftCheckbox.dataset.processing = 'true';
      giftCheckbox.style.pointerEvents = 'none';

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.showSimpleLoading();
      }

      if (isChecked) {
        // Add gift product to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              _gift_order: 'true',
            },
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('Gift product added to cart');

            // Lightweight update: refresh cart icon and footer totals
            return fetch('/cart.js')
              .then((response) => response.json())
              .then((cartData) => {
                // Update cart icon
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble) {
                  const cartCount = cartIconBubble.querySelector('.cart-count-bubble span');
                  if (cartCount) {
                    cartCount.textContent = cartData.item_count;
                  }
                }

                // Update cart footer totals
                if (typeof updateCartFooterTotals === 'function') {
                  updateCartFooterTotals(cartData);
                }

                // Hide loading
                if (cartDrawer) {
                  cartDrawer.hideSimpleLoading();
                }
              });
          })
          .catch((error) => {
            console.error('Error adding gift product:', error);
            giftCheckbox.checked = false;
            alert('Failed to add gift option. Please try again.');
            if (cartDrawer) {
              cartDrawer.hideSimpleLoading();
            }
          })
          .finally(() => {
            giftCheckbox.dataset.processing = 'false';
            giftCheckbox.style.pointerEvents = '';
          });
      } else {
        // Remove gift product from cart
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const giftItem = cart.items.find((item) => item.variant_id == variantId);
            if (giftItem) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: giftItem.key,
                  quantity: 0,
                }),
              });
            } else {
              console.log('Gift item not in cart');
              return Promise.resolve(null);
            }
          })
          .then((response) => {
            if (response) {
              return response.json();
            }
          })
          .then((data) => {
            console.log('Gift product removed from cart');

            // Lightweight update: refresh cart icon and footer totals
            return fetch('/cart.js')
              .then((response) => response.json())
              .then((cartData) => {
                // Update cart icon
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble) {
                  const cartCount = cartIconBubble.querySelector('.cart-count-bubble span');
                  if (cartCount) {
                    cartCount.textContent = cartData.item_count;
                  }
                }

                // Update cart footer totals
                if (typeof updateCartFooterTotals === 'function') {
                  updateCartFooterTotals(cartData);
                }

                // Hide loading
                if (cartDrawer) {
                  cartDrawer.hideSimpleLoading();
                }
              });
          })
          .catch((error) => {
            console.error('Error removing gift product:', error);
            // Sync with actual cart state
            syncGiftCheckboxState();
            alert('Failed to remove gift option. Please try again.');
            if (cartDrawer) {
              cartDrawer.hideSimpleLoading();
            }
          })
          .finally(() => {
            giftCheckbox.dataset.processing = 'false';
            giftCheckbox.style.pointerEvents = '';
          });
      }
    }

    function initializeGiftCheckbox() {
      const giftCheckbox = document.getElementById('cart-gift-checkbox');
      if (!giftCheckbox) return;

      // Remove existing listener to avoid duplicates
      giftCheckbox.removeEventListener('change', handleGiftCheckboxChange);

      // Add fresh listener
      giftCheckbox.addEventListener('change', handleGiftCheckboxChange);

      // Sync state with cart
      syncGiftCheckboxState();
    }

    // Initialize gift checkbox on page load
    initializeGiftCheckbox();

    // Initialize gift note listeners on page load
    initializeGiftNoteListeners();

    // Reinitialize gift checkbox and gift note after cart updates
    document.addEventListener('cart:drawer:refreshed', function () {
      setTimeout(() => {
        initializeGiftCheckbox();
        initializeGiftNoteListeners();
        cleanupRemovedGiftNotes();
      }, 100);
    });

    // Clean up gift notes for removed items
    function cleanupRemovedGiftNotes() {
      // Get all current gift note textareas
      const currentTextareas = document.querySelectorAll('.cart-item__gift-note-input');
      const currentItemKeys = new Set();

      currentTextareas.forEach((textarea) => {
        currentItemKeys.add(textarea.dataset.itemKey);
      });

      // Remove stored values for items that no longer exist
      Object.keys(giftNoteValues).forEach((itemKey) => {
        if (!currentItemKeys.has(itemKey)) {
          console.log('Clearing gift note for removed item:', itemKey);
          delete giftNoteValues[itemKey];

          // Also clear the cart attribute on the server
          const textarea = document.querySelector(`[data-item-key="${itemKey}"]`);
          if (textarea) {
            const attributeName = textarea.getAttribute('name')?.replace('attributes[', '').replace(']', '');
            if (attributeName) {
              clearGiftNoteAttribute(attributeName);
            }
          }
        }
      });
    }

    // Clear a gift note attribute from the cart
    function clearGiftNoteAttribute(attributeName) {
      const body = JSON.stringify({
        attributes: {
          [attributeName]: '',
        },
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Gift note attribute cleared:', attributeName);
        })
        .catch((error) => {
          console.error('Error clearing gift note attribute:', error);
        });
    }

    // === GIFT NOTE HANDLER ===
    let giftNoteTimeout = null;
    const giftNoteValues = {}; // Store gift note values in memory: { itemKey: { value, attributeName } }

    function handleGiftNoteInput(event) {
      const textarea = event.target;
      const noteValue = textarea.value;
      const itemKey = textarea.dataset.itemKey;
      const variantId = textarea.dataset.variantId;
      const productTitle = textarea.dataset.productTitle;
      const attributeName = textarea.getAttribute('name')?.replace('attributes[', '').replace(']', '');

      // Store value and attribute name in memory immediately
      giftNoteValues[itemKey] = {
        value: noteValue,
        attributeName: attributeName,
      };

      // Clear existing timeout
      if (giftNoteTimeout) {
        clearTimeout(giftNoteTimeout);
      }

      // Debounce the update (wait 500ms after user stops typing)
      giftNoteTimeout = setTimeout(() => {
        updateGiftNote(noteValue, itemKey, variantId, productTitle);
      }, 500);
    }

    function updateGiftNote(noteValue, itemKey, variantId, productTitle) {
      // Update cart attributes (order-level) instead of line item properties
      const textarea = document.querySelector(`#gift-note-${itemKey.replace(/:/g, '\\:')}`);
      const attributeName = textarea
        ? textarea.getAttribute('name').replace('attributes[', '').replace(']', '')
        : `Gift Message for ${productTitle}`;

      // Encode newlines as a special marker that Shopify won't strip
      // We'll use |NEWLINE| as a marker that can be decoded in order processing
      const encodedNote = noteValue.replace(/\n/g, '|NEWLINE|');

      // Use FormData to send the request
      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, encodedNote);

      fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Gift note updated successfully for item:', itemKey);
          console.log('Saved value with encoded newlines:', encodedNote);

          // Don't dispatch cart:updated to avoid triggering drawer refresh
          // The value is already in memory and will persist
        })
        .catch((error) => {
          console.error('Error updating gift note:', error);
        });
    }

    function initializeGiftNoteListeners() {
      const giftNoteInputs = document.querySelectorAll('.cart-item__gift-note-input');

      giftNoteInputs.forEach((input) => {
        const itemKey = input.dataset.itemKey;

        // Restore value from memory if it exists (after drawer refresh)
        if (giftNoteValues[itemKey] !== undefined) {
          input.value = giftNoteValues[itemKey].value || giftNoteValues[itemKey];
        }

        // Remove existing listeners to avoid duplicates
        input.removeEventListener('input', handleGiftNoteInput);
        // Add fresh listener
        input.addEventListener('input', handleGiftNoteInput);
      });
    }

    // Clean up gift notes for removed items
    function cleanupRemovedGiftNotes() {
      // Get all current gift note textareas
      const currentTextareas = document.querySelectorAll('.cart-item__gift-note-input');
      const currentItemKeys = new Set();

      currentTextareas.forEach((textarea) => {
        currentItemKeys.add(textarea.dataset.itemKey);
      });

      // Remove stored values for items that no longer exist
      Object.keys(giftNoteValues).forEach((itemKey) => {
        if (!currentItemKeys.has(itemKey)) {
          console.log('Clearing gift note for removed item:', itemKey);
          const giftNoteData = giftNoteValues[itemKey];
          const attributeName = typeof giftNoteData === 'object' ? giftNoteData.attributeName : null;

          // Clear from memory
          delete giftNoteValues[itemKey];

          // Also clear the cart attribute on the server if we have the attribute name
          if (attributeName && attributeName.includes('Gift Message')) {
            clearGiftNoteAttribute(attributeName);
          }
        }
      });
    }

    // Clear a gift note attribute from the cart
    function clearGiftNoteAttribute(attributeName) {
      const body = JSON.stringify({
        attributes: {
          [attributeName]: '',
        },
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Gift note attribute cleared:', attributeName);
        })
        .catch((error) => {
          console.error('Error clearing gift note attribute:', error);
        });
    }

    // === PRODUCT-LEVEL GIFT OPTION HANDLERS ===
    // New handler for gift offer quick add (similar to double offer)
    window.handleGiftOfferQuickAdd = function (button, variantId, enableGiftNote) {
      if (button.disabled) return;

      // Show loading state on button
      button.classList.add('loading');
      button.disabled = true;
      const originalContent = button.innerHTML;
      button.innerHTML = '⋯';

      // Show loading state on item wrapper
      const offerItem = button.closest('.cart-item__gift-offer-item');
      if (offerItem) {
        offerItem.style.opacity = '0.6';
        offerItem.style.pointerEvents = 'none';
      }

      // Add gift wrap to cart with _product_gift property
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _product_gift: 'true',
          },
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log('Gift wrap added to cart');

          // Fetch updated cart data
          return fetch('/cart.js')
            .then((res) => res.json())
            .then((cartData) => {
              // Dispatch cart:updated event with product-gift source
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: { cart: cartData, source: 'product-gift' },
                })
              );

              // Refresh cart drawer to show the new gift wrap item
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
                cartDrawerItems.onCartUpdate();
              }

              // Button and offer will be hidden by the DOM update, no need to reset
            });
        })
        .catch((error) => {
          console.error('Error adding gift wrap:', error);
          alert('Failed to add gift wrap. Please try again.');

          // Reset button state
          button.classList.remove('loading');
          button.disabled = false;
          button.innerHTML = originalContent;

          // Reset item wrapper state
          if (offerItem) {
            offerItem.style.opacity = '';
            offerItem.style.pointerEvents = '';
          }
        });
    };

    function updateCartFooterTotals(cartData) {
      // Update subtotal value
      const subtotalValue = document.querySelector('.cart-footer__subtotal-value');
      if (subtotalValue && window.formatIndianPrice) {
        const subtotal = (cartData.total_price / 100).toFixed(2);
        subtotalValue.textContent = window.formatIndianPrice(subtotal);
      }

      // Update breakdown values if expanded
      const breakdown = document.querySelector('.cart-footer__price-breakdown');
      if (breakdown && breakdown.classList.contains('expanded')) {
        // Re-fetch cart drawer section to update breakdown
        fetch(`/cart?section_id=cart-drawer&timestamp=${Date.now()}`)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newBreakdown = doc.querySelector('.cart-footer__price-breakdown');
            if (newBreakdown && breakdown) {
              breakdown.innerHTML = newBreakdown.innerHTML;
            }
          });
      }
    }

    // Handle quick add buttons in mini collection with loading states
    const miniCollectionContainer = document.querySelector('.cart-drawer__mini-collection');
    if (miniCollectionContainer) {
      // Initialize loaders for mini collection items
      initializeMiniCollectionLoaders();

      // Initialize navigation for mini collection
      initializeMiniCollectionNavigation();

      // Initialize cart footer toggle
      if (window.initializeCartFooterToggle) {
        window.initializeCartFooterToggle();
      }

      // Listen for form submissions (quick add forms)
      miniCollectionContainer.addEventListener('submit', function (event) {
        const form = event.target;
        if (form && form.matches('form[action*="/cart/add"]')) {
          const miniItem = form.closest('.cart-drawer__mini-collection-item');
          if (miniItem) {
            miniItem.classList.add('loading');

            // Remove loading state after completion
            setTimeout(() => {
              miniItem.classList.remove('loading');
              refreshCartDrawer();
            }, 1500);
          }
        }
      });

      // Listen for button clicks (quick add buttons)
      miniCollectionContainer.addEventListener('click', function (event) {
        const quickAddButton = event.target.closest('.quick-add__submit, [name="add"], .btn, button[type="submit"]');
        if (quickAddButton) {
          const miniItem = quickAddButton.closest('.cart-drawer__mini-collection-item');
          if (miniItem) {
            miniItem.classList.add('loading');

            // Remove loading state after completion
            setTimeout(() => {
              miniItem.classList.remove('loading');
              refreshCartDrawer();
            }, 1500);
          }
        }
      });
    }

    // Intercept fetch requests to cart/add.js for better loading state management
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const [resource, config] = args;

      // Check if this is a cart add request
      if (typeof resource === 'string' && resource.includes('/cart/add')) {
        return originalFetch
          .apply(this, args)
          .then((response) => {
            if (response.ok) {
              // Clear any existing loading states
              const loadingItems = document.querySelectorAll('.cart-drawer__mini-collection-item.loading');
              loadingItems.forEach((item) => {
                setTimeout(() => {
                  item.classList.remove('loading');
                }, 800);
              });

              // For gift-related adds (product gifts or order-level gift wrap),
              // we now handle UI updates in their own handlers and do NOT
              // refresh the entire cart drawer, to avoid triggering
              // recommendations reloads.
              let isGiftRequest = false;

              try {
                if (config && config.body) {
                  // body may be JSON (fetch) or FormData (quick add forms)
                  if (typeof config.body === 'string') {
                    const parsed = JSON.parse(config.body);
                    if (parsed && parsed.properties) {
                      if (parsed.properties._product_gift === 'true' || parsed.properties._gift_order === 'true') {
                        isGiftRequest = true;
                      }
                    }
                  } else if (config.body instanceof FormData) {
                    const props =
                      config.body.get('properties[_product_gift]') || config.body.get('properties[_gift_order]');
                    if (props === 'true') {
                      isGiftRequest = true;
                    }
                  }
                }
              } catch (e) {
                console.warn('Error inspecting cart/add request body for gift flags:', e);
              }

              if (!isGiftRequest) {
                // Non-gift quick-adds should still refresh the drawer
                setTimeout(() => {
                  refreshCartDrawer();
                }, 500);
              }
            } else {
              // Remove loading states on error
              const loadingItems = document.querySelectorAll('.cart-drawer__mini-collection-item.loading');
              loadingItems.forEach((item) => {
                item.classList.remove('loading');
              });
            }
            return response;
          })
          .catch((error) => {
            // Remove loading states on error
            const loadingItems = document.querySelectorAll('.cart-drawer__mini-collection-item.loading');
            loadingItems.forEach((item) => {
              item.classList.remove('loading');
            });
            throw error;
          });
      }

      return originalFetch.apply(this, args);
    };

    // Debounced cart refresh to prevent multiple rapid updates
    let cartRefreshTimeout;
    function debouncedCartRefresh(source, event) {
      clearTimeout(cartRefreshTimeout);
      cartRefreshTimeout = setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('active')) {
          console.log('Debounced cart refresh triggered by:', source);
          refreshCartDrawer();
        }
      }, 150); // 150ms debounce to prevent rapid successive calls
    }

    // Helper function to get product image URL with proper fallback chain and optimization
    function getProductImageURL(product, size = '533x533') {
      let imageUrl = '';

      // Priority 1: featured_image
      if (product.featured_image) {
        imageUrl = product.featured_image;
      }
      // Priority 2: first image from images array
      else if (product.images && Array.isArray(product.images) && product.images.length > 0) {
        imageUrl = product.images[0];
      }
      // Priority 3: image property (some API responses use this)
      else if (product.image) {
        imageUrl = product.image;
      }

      // Optimize image URL with proper sizing parameters if we have a URL
      if (imageUrl) {
        // Remove any existing size parameters
        imageUrl = imageUrl.split('?')[0];

        // Add optimized size parameter for Shopify CDN
        // Format: _533x533_crop_center for consistent sizing
        if (imageUrl.includes('cdn.shopify.com')) {
          // Insert size before file extension
          const lastDotIndex = imageUrl.lastIndexOf('.');
          if (lastDotIndex > 0) {
            const extension = imageUrl.substring(lastDotIndex);
            const baseUrl = imageUrl.substring(0, lastDotIndex);
            imageUrl = `${baseUrl}_${size}_crop_center${extension}`;
          }
        }
      }

      return imageUrl;
    }

    // Function to create a product card element matching card-product design
    function createProductCard(product) {
      const div = document.createElement('div');
      div.className = 'cart-drawer__mini-collection-item';

      const quickAddType = window.cartDrawerQuickAddType || 'button';
      const firstVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
      const isAvailable = firstVariant && firstVariant.available;

      // Get product image URL with proper fallback chain and optimization
      const imageUrl = getProductImageURL(product);

      // Price logic matching card-price.liquid
      // Check if product has variants with different prices
      let priceVaries = false;
      let priceMin = firstVariant ? firstVariant.price : product.price || 0;
      let priceMax = priceMin;
      let compareAtPriceMin = null;

      if (product.variants && product.variants.length > 1) {
        const prices = product.variants.map((v) => v.price);
        priceMin = Math.min(...prices);
        priceMax = Math.max(...prices);
        priceVaries = priceMin !== priceMax;

        // Get minimum compare_at_price if exists
        const compareAtPrices = product.variants.map((v) => v.compare_at_price).filter((p) => p && p > 0);
        if (compareAtPrices.length > 0) {
          compareAtPriceMin = Math.min(...compareAtPrices);
        }
      }

      const compareAtPrice =
        firstVariant && firstVariant.compare_at_price ? firstVariant.compare_at_price : compareAtPriceMin;
      const price = firstVariant ? firstVariant.price : priceMin;
      const showStartsAt = priceVaries;

      // Build tags matching card-product logic
      let tagsHTML = '';
      const automaticTags = [];
      const customTags = [];

      // Add automatic status tags
      if (!isAvailable) {
        automaticTags.push('<span class="badge card__tag card__tag--sold-out">Sold Out</span>');
      }

      // Process custom tags from metafield
      if (product.metafields && product.metafields.custom && product.metafields.custom.tags) {
        const customTagsArray = product.metafields.custom.tags;
        if (Array.isArray(customTagsArray) && customTagsArray.length > 0) {
          customTagsArray.forEach((tag) => {
            const tagLower = tag.toLowerCase();
            if (tagLower.includes('rakhi')) return; // Rakhi labels suppressed sitewide
            let tagClass = 'badge card__tag';

            // Check for specific status-related tags
            if (tagLower.includes('new') || tagLower.includes('latest')) {
              tagClass = 'badge card__tag card__tag--new';
            } else if (tagLower === 'summer sale') {
              tagClass = 'badge card__tag card__tag--summer-sale';
            } else if (tagLower.includes('limited') || tagLower.includes('exclusive')) {
              tagClass = 'badge card__tag card__tag--limited';
            } else {
              tagClass = 'badge card__tag card__tag--default';
            }

            customTags.push(`<span class="${tagClass}">${tag}</span>`);
          });
        }
      }

      // Combine tags if any exist
      if (automaticTags.length > 0 || customTags.length > 0) {
        tagsHTML = `<div class="card__tags">${automaticTags.join('')}${customTags.join('')}</div>`;
      }

      // Build quick add button matching card-product design
      let quickAddButton = '';
      if (quickAddType === 'standard' && firstVariant) {
        const productFormId = `quick-add-rec-${product.id}`;
        quickAddButton = `
          <div class="quick-add no-js-hidden">
            <product-form data-hide-errors="true">
              <form method="post" action="/cart/add" id="${productFormId}" class="quick-add-form" novalidate="novalidate" data-type="add-to-cart-form">
                <input type="hidden" name="id" value="${firstVariant.id}" class="product-variant-id" ${
          !isAvailable ? 'disabled' : ''
        }>
                <button
                  id="${productFormId}-submit"
                  type="submit"
                  name="add"
                  class="quick-add__submit button button--secondary ${!isAvailable ? 'button--sold-out' : ''}"
                  aria-haspopup="dialog"
                  aria-labelledby="${productFormId}-submit"
                  aria-live="polite"
                  ${!isAvailable ? 'disabled' : ''}
                >
                  ${
                    !isAvailable
                      ? '<span class="sold-out-text">Sold Out</span>'
                      : `<svg class="plus-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4V16M4 10H16" stroke="#dc600e" stroke-width="2" stroke-linecap="round"/>
                    </svg>`
                  }
                  <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                  </svg>
                </button>
              </form>
            </product-form>
          </div>
        `;
      }

      // Build card matching card-product structure
      div.innerHTML = `
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <h2 class="card__heading h5">
              <a href="/products/${product.handle}" class="full-unstyled-link" aria-labelledby="CardLink-rec-${
        product.id
      }">
                ${product.title}
              </a>
            </h2>
            ${tagsHTML}
            <div class="card-image-container">
              <a href="/products/${product.handle}" class="full-unstyled-link card-image-link">
                ${
                  imageUrl
                    ? `<div class="card-image-wrapper">
                        <div class="card-image-loading-spinner" style="display: block;">
                          <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                        <img 
                          src="${imageUrl}" 
                          alt="${product.title}" 
                          loading="lazy" 
                          class="card-image" 
                          width="533" 
                          height="533" 
                          style="aspect-ratio: 1/1; object-fit: cover; display: none;"
                          onload="this.style.display='block'; this.previousElementSibling.style.display='none';"
                          onerror="this.style.display='none'; this.previousElementSibling.style.display='none'; this.parentElement.innerHTML='<div class=&quot;card-image-placeholder&quot;><svg xmlns=&quot;http://www.w3.org/2000/svg&quot; viewBox=&quot;0 0 525.5 525.5&quot;><path d=&quot;M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z&quot;></path><path d=&quot;M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z&quot;></path></svg></div>';"
                        >
                      </div>`
                    : '<div class="card-image-placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path></svg></div>'
                }
              </a>
            </div>
            <div class="card__content">
              <div class="card__information">
                <div class="card-information">
                  <div class="price-and-cart-row">
                    <div class="price price--recommendation ${
                      compareAtPrice && compareAtPrice > price ? 'price--on-sale' : ''
                    }">
                      ${
                        compareAtPrice && compareAtPrice > price
                          ? `<div class="price__stacked">
                              <div class="price__sale-row">
                                ${showStartsAt ? '<span class="price-starts-at">Starts at</span>' : ''}
                                <s class="price-item price-item--compare">${formatPrice(
                                  showStartsAt ? compareAtPriceMin : compareAtPrice
                                )}</s>
                              </div>
                              <span class="price-item price-item--sale">${formatPrice(
                                showStartsAt ? priceMin : price
                              )}</span>
                            </div>`
                          : `<div class="price__stacked">
                              ${showStartsAt ? '<span class="price-starts-at">Starts at</span>' : ''}
                              <span class="price-item price-item--regular">${formatPrice(
                                showStartsAt ? priceMin : price
                              )}</span>
                            </div>`
                      }
                    </div>
                    ${quickAddButton}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      // Add event listener for quick add form with per-card loading states and request serialization
      const form = div.querySelector('.quick-add-form');
      if (form) {
        // Track if a request is in progress for this specific card
        let isRequestInProgress = false;

        form.addEventListener('submit', function (e) {
          e.preventDefault();

          // Implement request serialization - prevent concurrent requests for this card
          if (isRequestInProgress) {
            console.log('Request already in progress for this card, ignoring duplicate submission');
            return;
          }

          const miniItem = form.closest('.cart-drawer__mini-collection-item');
          const button = form.querySelector('button[type="submit"]');
          const plusIcon = button.querySelector('.plus-icon');
          const spinner = button.querySelector('.spinner');

          // Set per-card loading state
          isRequestInProgress = true;
          if (miniItem) {
            miniItem.classList.add('loading');
          }

          button.disabled = true;
          if (plusIcon) plusIcon.style.display = 'none';
          if (spinner) spinner.style.display = 'block';

          const formData = new FormData(form);

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              // Dispatch product added event
              document.dispatchEvent(
                new CustomEvent('product:added-to-cart', {
                  detail: { product_id: data.product_id, variant_id: data.variant_id },
                })
              );

              // Ensure single recommendations refresh after successful add
              setTimeout(() => {
                if (typeof refreshCartDrawer === 'function') {
                  refreshCartDrawer();
                } else {
                  // Fallback: trigger cart update
                  const cartDrawerItems = document.querySelector('cart-drawer-items');
                  if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
                    cartDrawerItems.onCartUpdate();
                  }
                }
              }, 300);
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);

              // Show error message to user
              const errorMessage = document.createElement('div');
              errorMessage.className = 'quick-add-error-message';
              errorMessage.textContent = 'Failed to add to cart. Please try again.';
              errorMessage.style.cssText =
                'position: absolute; top: 100%; left: 0; right: 0; background: #dc3545; color: white; padding: 0.5rem; font-size: 0.875rem; text-align: center; border-radius: 4px; margin-top: 0.5rem; z-index: 10;';

              if (miniItem) {
                miniItem.style.position = 'relative';
                miniItem.appendChild(errorMessage);

                // Remove error message after 3 seconds
                setTimeout(() => {
                  errorMessage.remove();
                }, 3000);
              }

              // Reset button state on error
              button.disabled = false;
              if (plusIcon) plusIcon.style.display = 'block';
              if (spinner) spinner.style.display = 'none';

              // Clear per-card loading state
              if (miniItem) {
                miniItem.classList.remove('loading');
              }

              // Reset request flag
              isRequestInProgress = false;
            });
        });
      }

      return div;
    }

    // Helper function to format price in INR with proper Indian number formatting
    function formatPriceINR(cents) {
      // Handle edge cases
      if (cents === null || cents === undefined || isNaN(cents)) {
        return '₹0.00';
      }

      // Handle negative numbers
      const isNegative = cents < 0;
      const absoluteCents = Math.abs(cents);

      // Convert cents to rupees
      const rupees = absoluteCents / 100;

      // Handle very large numbers (prevent overflow)
      if (rupees > Number.MAX_SAFE_INTEGER / 100) {
        return isNegative ? '-₹∞' : '₹∞';
      }

      // Split into integer and decimal parts
      const parts = rupees.toFixed(2).split('.');
      let integerPart = parts[0];
      const decimalPart = parts[1];

      // Apply Indian comma formatting
      let formatted = '';
      const len = integerPart.length;

      if (len <= 3) {
        formatted = integerPart;
      } else {
        // Indian format: last 3 digits, then groups of 2
        const lastThree = integerPart.slice(-3);
        const remaining = integerPart.slice(0, -3);

        // Add commas every 2 digits for the remaining part (from right to left)
        const reversedRemaining = remaining.split('').reverse().join('');
        const formattedRemaining = reversedRemaining.match(/.{1,2}/g).join(',');
        formatted = formattedRemaining.split('').reverse().join('') + ',' + lastThree;
      }

      // Return formatted price with currency symbol and sign
      return isNegative ? `-₹${formatted}.${decimalPart}` : `₹${formatted}.${decimalPart}`;
    }

    // Alias for backward compatibility
    function formatPrice(cents) {
      return formatPriceINR(cents);
    }

    // Enhanced cart event listeners for complementary product caching ONLY
    // Note: Drawer refresh is now handled by cart-drawer.js dispatching cart:drawer:refreshed
    // which is handled by the consolidated event handler above
    const cartUpdateEvents = [
      'cart:updated',
      'product:added-to-cart',
      'quick-add:success',
      'cart:change',
      'cart:refresh',
      'theme:cart:update',
    ];

    cartUpdateEvents.forEach((eventName) => {
      document.addEventListener(eventName, function (event) {
        console.log(`${eventName} event fired - handling cache management only`);

        // Cart updates are handled by cart:drawer:refreshed event
        // which triggers the complementary recommendations system
      });
    });

    // Handle double offer quick add with loading states
    window.handleDoubleOfferQuickAdd = function (button, variantId) {
      if (button.disabled) return;

      // Show loading state on button
      button.classList.add('loading');
      button.disabled = true;
      const originalContent = button.innerHTML;
      button.innerHTML = '⋯';

      // Show loading state on card
      const card = button.closest('.double-offer-card');
      if (card) {
        card.classList.add('loading');
      }

      // Show overall cart loader like mini collection does
      showCartLoader();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((data) => {
          // Fetch updated cart data to get current item count
          return fetch('/cart.js')
            .then((res) => res.json())
            .then((cartData) => {
              // Dispatch product added event
              document.dispatchEvent(
                new CustomEvent('product:added-to-cart', {
                  detail: { product_id: data.product_id, variant_id: data.variant_id },
                })
              );

              // Dispatch cart:updated event to update header cart icon
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: { cart: cartData },
                })
              );

              // Use the same refresh mechanism as mini collection
              setTimeout(() => {
                if (typeof refreshCartDrawer === 'function') {
                  refreshCartDrawer();
                } else {
                  // Fallback: trigger cart update
                  const cartDrawerItems = document.querySelector('cart-drawer-items');
                  if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
                    cartDrawerItems.onCartUpdate();
                  }
                }
              }, 300);
            });
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          button.classList.remove('loading');
          button.disabled = false;
          button.innerHTML = originalContent;

          if (card) {
            card.classList.remove('loading');
          }

          // Hide cart loader on error
          hideCartLoader();
        });
    };

    // Add loader for remove button clicks
    document.addEventListener('click', function (event) {
      if (event.target.closest('cart-remove-button')) {
        showCartLoader();
      }

      // Handle coupon and variant expand triggers
      if (event.target.classList.contains('cart-card__expand-trigger')) {
        const targetId = event.target.getAttribute('data-target');
        const hiddenElement = document.getElementById(targetId);
        if (hiddenElement) {
          hiddenElement.classList.toggle('show');
          event.target.textContent = hiddenElement.classList.contains('show') ? '−' : '...';
        }
      }
    });
  });
